import Address from "typedef/Address";
import parseMoney from "utils/parseMoney";
import { useParams } from "react-router-dom";
import { RegisterFormInputs } from "./useRegisterForm";
import { useInvite } from "context/Invite/useInviteContext";

const useParseToSubmit = () => {
  const invite = useInvite();
  const params = useParams();
  const sourceId = params["sourceId"];

  return (data: RegisterFormInputs) => {
    const annualIncome = parseMoney(data.annualIncome);
    const homeValue = parseMoney(data.homeValue);
    const requestedNewLoan = parseMoney(data.requestedNewLoan);
    const currentLoanBalance = parseMoney(data.currentLoanBalance);
    const phoneNumber = data.phoneNumber.replace(/ /g, "");
    const creditScore = parseInt(data.creditScore.split(" ")[0]);
    const { street_line, ...restOfAddress } = data.address;
    const address = {
      street: street_line,
      ...restOfAddress,
    };
    let borrowerAddress: (Address & { street?: string }) | undefined;
    if (data.borrowerAddress) {
      const { ...propsBorrowerAddress } = data.borrowerAddress;

      borrowerAddress = {
        street: propsBorrowerAddress?.street_line,
        ...propsBorrowerAddress,
      };
    }

    return {
      address,
      borrowerAddress,
      email: data.email?.trim(),
      hasAcceptTerms: true,
      agreeNotifications: true,
      password: data.password,
      lastName: data.lastName,
      phoneNumber,
      firstName: data.firstName,
      useProceeds: data.useProceeds,
      occupancy: data.occupancy,
      homeValue: homeValue,
      employmentType: data.employmentType,
      annualIncome: annualIncome,
      requestedNewLoan: requestedNewLoan,
      currentLoanBalance: currentLoanBalance,
      creditScore,
      inviteCode: invite?.code,
      sourceId: sourceId,
    };
  };
};

export default useParseToSubmit;
